import type { DecisionEngineDestinationDefinition } from "./definition";
import { hightouchPayloadMapping } from "./sync-config-helpers";

/**
 * Delivery happens through the CEP outbox loader, never through a sync, so no
 * managed sync is created for a native delivery channel or message. The sync
 * config generator still exists for the preview path, which keys rows by the
 * campaign the agent chose and sends the standard payload.
 */
export const nativeDeliveryDefinition: DecisionEngineDestinationDefinition = {
  destinationType: "hightouch-native-delivery",
  category: "trigger",
  syncStrategy: {
    shouldManageSyncs: false,
  },
  generateSyncConfig: ({ producer, messageTags }) => ({
    type: "trigger",
    campaignId: { type: "standard", from: "campaign_id" },
    mappings: [hightouchPayloadMapping({ producer, messageTags })],
  }),
};
